export const beheer = {
  title: "Beheer",
  back: "Terug naar de baan",
  facts: "{{klasse}}, niveau {{level}}, {{datum}}",
  open: "Naar beheer",
  openWhat: "Conflicten, de stand in VBS en de vergrendeling van deze baan.",
  offline:
    "Beheer werkt alleen met verbinding. Je jurylijsten kun je wel offline invullen. Zodra je weer online bent, verschijnt beheer hier.",
  closed: "Deze baan is gesloten in VBS. VBS neemt geen wijzigingen meer aan, dus hier kan niets meer veranderen.",
  // The tabs, in the order of the wedstrijddag. The tab is the page's only title.
  secties: {
    nav: "Onderdelen van beheer",
    error: "Actie nodig",
    warning: "Aandacht nodig",
    overzicht: { label: "Overzicht" },
    waarnemers: { label: "Waarnemers" },
    conflicten: { label: "Conflicten" },
    ploegen: { label: "Ploegen" },
    afronden: { label: "Afronden" },
  },
  // Why a tab needs attention, keyed by the signal it resolves.
  aandacht: {
    vbs: {
      why_one: "1 ploeg staat niet helemaal in VBS.",
      why_other: "{{count}} ploegen staan niet helemaal in VBS.",
    },
    conflicten: {
      why_one: "1 conflict wacht op je keuze.",
      why_other: "{{count}} conflicten wachten op je keuze.",
    },
    waarnemers: {
      why_one: "1 functie heeft nog geen waarnemer.",
      why_other: "{{count}} functies hebben nog geen waarnemer.",
    },
  },
  overzicht: {
    inVbs: "In VBS",
    afwijking: "Afwijking",
    mislukt: "Mislukt",
    vergrendeld: "Vergrendeld",
    rustig: "Niets vraagt nu aandacht.",
  },
  failed: "Dat is niet gelukt ({{status}}). Probeer het opnieuw.",
  locked: "Dat kan niet meer: deze ploeg is vergrendeld of de baan is gesloten in VBS.",
  status: {
    "0": "Wacht op versturen",
    "1": "In VBS",
    "2": "Afwijking",
    "3": "Mislukt",
  },
  ploegen: {
    label: "Ploegen van deze baan",
    lockedBadge: "Vergrendeld",
    empty: "Deze baan heeft geen ploegen.",
    back: "Alle ploegen",
  },
  ploeg: {
    pushedAt: "Laatst naar VBS gestuurd: {{when}}",
    neverPushed: "Nog niet naar VBS gestuurd.",
    failed: "Het versturen naar VBS is mislukt. VBS Jury probeert het later opnieuw.",
    lock: "Ploeg vergrendelen",
    unlock: "Vergrendeling opheffen",
    lockWhat: "Een vergrendelde ploeg neemt geen antwoorden meer aan. VBS Jury stuurt de ploeg dan meteen naar VBS.",
    unlockWhat: "Deze ploeg is vergrendeld. Hef de vergrendeling op als waarnemers nog iets moeten aanpassen.",
    overrides: "Antwoorden aanpassen",
  },
  afwijking: {
    title: "Afwijking in VBS",
    what_one:
      "Iemand heeft 1 veld van deze ploeg in VBS aangepast. VBS Jury stuurt de andere antwoorden gewoon door. Dit veld stuurt VBS Jury pas weer als jij kiest wat telt.",
    what_other:
      "Iemand heeft {{count}} velden van deze ploeg in VBS aangepast. VBS Jury stuurt de andere antwoorden gewoon door. Deze velden stuurt VBS Jury pas weer als jij kiest wat telt.",
    opmerkingOf: "Opmerking bij: {{vraag}}",
    field: "Veld",
    inVbs: "Nu in VBS",
    inVbsJury: "VBS Jury stuurt",
    empty: "(leeg)",
    keepVbs: "Houd VBS aan",
    keepVbsWhat: "De waarden uit VBS worden de antwoorden van de beheerder in VBS Jury.",
    overwrite: "Overschrijf VBS",
    overwriteWhat: "VBS Jury zet zijn eigen antwoorden terug in VBS. De wijziging in VBS gaat verloren.",
    overwriteTitle: "VBS overschrijven?",
    overwriteConfirm: "Overschrijven",
  },
  notities: {
    title: "Notities",
    none: "Waarnemers hebben bij deze ploeg geen notitie geschreven.",
    by: "{{name}}, {{when}}",
  },
  notInVbs: {
    title: "Niet in VBS",
    what_one: "1 veld van deze ploeg staat niet in VBS. De andere antwoorden zijn wel verstuurd.",
    what_other: "{{count}} velden van deze ploeg staan niet in VBS. De andere antwoorden zijn wel verstuurd.",
    why: "Waarom",
    refused: "VBS neemt dit antwoord niet aan.",
    notStored: "VBS heeft dit antwoord niet bewaard. VBS Jury probeert het opnieuw.",
  },
  conflicten: {
    open: "{{count}} open",
    none: "Er zijn geen conflicten. Waarnemers zijn het overal eens.",
    what: "Waarnemers gaven hier een verschillend antwoord. Tot je kiest, telt het nieuwste antwoord.",
    readOnly: "Alleen de beheerder kiest welk antwoord telt.",
    choose: "Kies dit antwoord",
    answer: "{{value}} van {{name}}",
    unknownName: "Onbekende waarnemer",
  },
  waarnemers: {
    title: "Indeling",
    what: "De indeling komt uit VBS. Je kunt waarnemers toevoegen en een indeling uit VBS verbergen. Een verborgen indeling komt bij de volgende import niet terug.",
    name: "Naam",
    functie: "Functie",
    source: "Herkomst",
    actions: "Acties",
    algemeen: "Algemeen",
    fromVbs: "VBS",
    fromBeheerder: "Beheerder",
    hiddenBadge: "Verborgen",
    hide: "Verbergen",
    unhide: "Weer tonen",
    remove: "Verwijderen",
    removeTitle: "{{name}} verwijderen van deze functie?",
    removeWhat: "De waarnemer ziet deze jurylijst dan niet meer. Antwoorden die al zijn gegeven, blijven bewaard.",
    removeConfirm: "Verwijderen",
    none: "Er zijn nog geen waarnemers aan deze baan toegewezen.",
    send: "Inloglinks versturen",
    sendWhat: "Elke zichtbare waarnemer met een e-mailadres krijgt een inloglink die 14 dagen geldig is.",
    sent_one: "1 inloglink verstuurd.",
    sent_other: "{{count}} inloglinks verstuurd.",
    tooOften: "Je hebt al te veel inloglinks verstuurd. Probeer het later opnieuw.",
    showCode: "Toon code",
    codeFor: "Inlogcode voor {{name}}",
    codeWhat: "Geef deze code door. De waarnemer vult hem in bij Inloggen. Een e-mailadres is niet nodig.",
    codeValid: "Geldig tot {{moment}}. De code werkt één keer en geeft alleen de rechten van een waarnemer.",
  },
  assign: {
    title: "Waarnemer toewijzen",
    what: "Kies een waarnemer uit VBS en de functie die hij of zij op deze baan beoordeelt.",
    search: "Zoek op naam",
    results: "Waarnemers die passen bij je zoekopdracht",
    noMatch: "Geen waarnemer gevonden met deze naam.",
    pickFirst: "Zoek en kies eerst een waarnemer.",
    chosen: "Gekozen: {{name}}",
    submit: "Toewijzen",
    done: "Toegewezen.",
  },
  lockBaan: {
    title: "Baan vergrendelen",
    what: "Vergrendel de baan als de wedstrijd klaar is. Dan neemt geen enkele ploeg nog antwoorden aan en stuurt VBS Jury alles een laatste keer naar VBS.",
    button: "Baan vergrendelen",
    confirmTitle: "Deze baan vergrendelen?",
    confirmWhat: "Alle ploegen worden vergrendeld en een laatste keer naar VBS gestuurd.",
    closeInVbs: "Sluit de baan ook in VBS",
    closeInVbsWhat:
      "Dit kun je niet ongedaan maken. Na het sluiten neemt VBS geen wijzigingen meer aan, ook niet van de rekenkamer in VBS.",
    confirm: "Vergrendelen",
    confirmAndClose: "Vergrendelen en sluiten in VBS",
    cancel: "Annuleren",
    done: "De baan is vergrendeld.",
    notInVbs:
      "De baan is vergrendeld, maar niet gesloten in VBS: nog niet elke ploeg staat helemaal in VBS. Kijk bij de ploegen wat er ontbreekt.",
  },
  overrides: {
    title: "Antwoorden van {{ploeg}}",
    description: "Als beheerder bepaal je zelf het antwoord dat telt. Jouw antwoord gaat boven dat van elke waarnemer.",
    back: "Terug naar beheer",
    label: "Vragen van deze ploeg",
    vraag: "Vraag",
    counts: "Telt",
    none: "Geen antwoord",
    override: "Beheerder",
    choose: "Kies een vraag om het antwoord aan te passen.",
    backToList: "Alle vragen",
    currentWaarnemer: "Nu telt {{value}}, het antwoord van een waarnemer.",
    currentOverride: "Nu telt {{value}}, jouw antwoord als beheerder.",
    currentNone: "Nog geen antwoord.",
    value: "Antwoord",
    pick: "Kies een antwoord",
    time: "Tijd als minuten:seconden",
    opmerking: "Opmerking",
    save: "Opslaan",
    saved: "Opgeslagen.",
    remove: "Mijn antwoord verwijderen",
    removeTitle: "Jouw antwoord verwijderen?",
    removeWhat: "Dan telt weer het antwoord van de waarnemers. Je kunt later opnieuw een eigen antwoord geven.",
    removeConfirm: "Verwijderen",
    removed: "Verwijderd. Het antwoord van de waarnemers telt weer.",
    valueRequired: "Kies een antwoord.",
    valueNotAllowed: "Dit antwoord is bij deze vraag niet toegestaan.",
    timeInvalid: "Vul de tijd in als minuten:seconden, bijvoorbeeld 3:25.",
    opmerkingRequired: "Bij een O of K is een opmerking verplicht.",
    locked: "Deze ploeg is vergrendeld. Vraag de beheerder de vergrendeling op te heffen.",
  },
} as const;
